module.exports = __webpack_public_path__ + "SourceSansPro-Light.47c37e8297b0bd9d19b5.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Light.woff
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Light.woff
// module chunks = styles